<div class="ug-container">
  <app-title-container>
    <h1>Fuzzy Name Matching Guide</h1>
  </app-title-container>

  <app-divider height="2px"></app-divider>
  <div class="overflow-content">
    @if (isLoading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else {
      <div class="actions-container" *appIsRiskManager>
        @if (!isEditMode()) {
          <button
            class="clickable-text ml-auto"
            (click)="toggleEditMode()"
            aria-label="Edit Fuzzy Name Matching Guide"
            matTooltip="Edit Fuzzy Name Matching Guide"
          >
            <span class="material-symbols-outlined action-icon"> edit </span>
          </button>
        }
      </div>

      @if (isEditMode()) {
        <div class="editable-container">
          <quill-editor bounds="self" class="quill-editor-container" [formControl]="descriptionControl"></quill-editor>
          <div>
            <button mat-button (click)="toggleEditMode()" matTooltip="Cancel changes">Cancel</button>
            <button mat-flat-button (click)="updateManual()" matTooltip="Update Fuzzy Name Matching Guide">
              <mat-icon fontIcon="check"></mat-icon> Submit
            </button>
          </div>
        </div>
      } @else {
        <div class="viewable-container">
          <quill-view class="white-section" [content]="descriptionControl.value" format="html"></quill-view>
        </div>
      }
    }
  </div>
</div>
